import React, { useCallback } from "react";

import { capitalize } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import CheckboxLabel from "@busbud/design-system-components/dist/CheckboxLabel";
import SeatBedMD from "@busbud/design-system-components/dist/Icons/SeatBed/MD";
import SeatSelectionMD from "@busbud/design-system-components/dist/Icons/SeatSelection/MD";

import { getSelectedClasses } from "@app/modules/results/selectors/get-selected-classes";
import { addClass, removeClass } from "@app/modules/results/state/filters";

import { useFacetedSearch } from "../hooks/useFacetedSearch";

const getClassIcon = (key: string | number) => {
  switch (key) {
    case "salon cama":
      return <SeatBedMD color="icon.primary.opaque" />;
    case "semi cama":
      return <SeatSelectionMD color="icon.primary.opaque" />;
    default:
      return <SeatSelectionMD color="icon.primary.opaque" />;
  }
};

export const CheckboxClasses = () => {
  const dispatch = useDispatch();
  const faceted_search = useFacetedSearch();
  const aggregation = faceted_search.getAggregation("classes");
  const state_filter_class_values = useSelector(getSelectedClasses);

  const getCheckboxValue = useCallback(
    (key: string | number) => {
      return state_filter_class_values.includes(String(key));
    },
    [state_filter_class_values]
  );

  const buckets_data = React.useMemo(() => {
    return aggregation?.buckets.map(({ key, doc_count }) => ({
      key,
      disabled: doc_count <= 0,
      value: getCheckboxValue(key),
      label: `${capitalize(String(key))} (${doc_count})`
    }));
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  }, [aggregation.buckets, getCheckboxValue]);

  const handleCheckboxChange = useCallback(
    (key: string | number) => {
      const stringified_key = `${key}`;

      state_filter_class_values.includes(stringified_key)
        ? dispatch(removeClass(stringified_key))
        : dispatch(addClass(stringified_key));
    },
    [dispatch, state_filter_class_values]
  );

  return (
    <>
      {buckets_data?.map(({ key, disabled, value, label }) => (
        <CheckboxLabel
          key={key}
          outlined
          shape="square"
          label={label}
          value={value}
          checked={value}
          disabled={disabled}
          startIcon={getClassIcon(key)}
          onChange={() => {
            handleCheckboxChange(key);
          }}
        />
      ))}
    </>
  );
};
